import { Radio } from '@client/new/components/basic';
import { Typography } from '@design-system/components/typography/typography';
import { Col, Row } from '@design-system/components/grid/grid';
import { ErrorMessage } from '@client/new/components/Label';
import { SelectProps } from './MenuSelect';
import React, { forwardRef } from 'react';

type Props = SelectProps<string> &
  React.DetailedHTMLProps<
    React.InputHTMLAttributes<HTMLInputElement>,
    HTMLInputElement
  >;
export const RadioSelect = forwardRef<HTMLInputElement, Props>(
  ({ error, ...p }, ref) => (
    <Col style={{ gap: 0 }}>
      <Row gap="s">
        {p.options.map((o, i) => (
          <Row
            key={i}
            style={{
              cursor: 'pointer',
              alignItems: 'center',
            }}
            onClick={() =>
              // eslint-disable-next-line @typescript-eslint/no-explicit-any
              p.onChange({ target: { name: p.name, value: o.value } } as any)
            }
          >
            <Typography variant="body" size="medium" fontWeight="normal">
              {o.label}
            </Typography>
            <Radio
              name={p.name}
              checked={p.value === o.value}
              value={o.value}
              // eslint-disable-next-line @typescript-eslint/no-explicit-any
              ref={ref as any}
            />
          </Row>
        ))}
      </Row>
      <ErrorMessage content={error} />
    </Col>
  ),
);
